/*
 * humo-tabs.js — Humo Commerce
 * Вкладки секции sections/humo-product-tabs.liquid: переключение hidden у панелей,
 * клавиатура по шаблону WAI-ARIA Tabs (стрелки, Home/End).
 * Панели уже в разметке — без JS видна первая.
 */
(function () {
  'use strict';

  var ACTIVE = 'humo-ptabs__tab--active';

  function initTabs(root) {
    if (root.getAttribute('data-humo-tabs-ready') === 'true') return;
    var tabs = root.querySelectorAll('[data-humo-tab]');
    if (tabs.length < 2) return;
    root.setAttribute('data-humo-tabs-ready', 'true');

    function select(index, focus) {
      Array.prototype.forEach.call(tabs, function (tab, i) {
        var on = i === index;
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        tab.classList.toggle(ACTIVE, on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        if (panel) panel.hidden = !on;
      });
      if (focus) tabs[index].focus();
    }

    Array.prototype.forEach.call(tabs, function (tab, i) {
      tab.addEventListener('click', function () { select(i, false); });

      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        e.preventDefault();
        select(next, true);
      });

      // Редактор темы: выбранный блок-вкладку открываем
      tab.addEventListener('shopify:block:select', function () { select(i, false); });
    });
  }

  function init() {
    var roots = document.querySelectorAll('[data-humo-tabs]');
    Array.prototype.forEach.call(roots, function (root) {
      try {
        initTabs(root);
      } catch (e) {
        console.error('[humo-tabs] init failed', e);
      }
    });
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
